import createSvgIcon from '../Utils/CreateSvgIcon';

export const Clock = createSvgIcon(
  <path
    d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11 6L11 12L11 12.4142L11.2929 12.7071L15.2929 16.7071L16.7071 15.2929L13 11.5858L13 6L11 6Z"
    fillRule="evenodd"
  />,
  'Clock',
);
